import { createCustomToggle, customSearchBar, cloneHeaderItems } from './helpers/helpers';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  createCustomToggle();
  customSearchBar('Search on this website...');
  cloneHeaderItems();
});

// test comment
